import { render, staticRenderFns } from "./CMaterialesInstalados.vue?vue&type=template&id=4386c724&"
import script from "./CMaterialesInstalados.vue?vue&type=script&lang=js&"
export * from "./CMaterialesInstalados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports